import { lazy } from 'react';

import { ReportType } from 'src/models/report';
import { CRoutes } from 'src/routes';
import { getLinkRoute } from 'src/routes/helpers';

const ReportPage = lazy(() => import('src/pages/Report'));
const ReportsListPage = lazy(() => import('src/pages/Reports'));

const types: ReportType[] = [
  'donations',
  'donors',
  'experiences',
  'p2pmembers',
  'p2pteams',
  'items',
  'rafflewinners',
  'sweepstakeswinners',
  'auctionwinners',
  'bidders',
  'auctionitems',
  'saleitems',
  'recurringdonations',
  'eventattendees',
  'returningdonors',
  'failingrecurringdonations',
  'oneplusyearactiverecurringdonors',
  'inactivedonors',
  'cancelledrecurringdonors',
  'auctiondonors',
];

const ROUTE_REPORTS = '/reports/:permanentUrl?';

export const getCustomReportRoute = (type: ReportType, id: string | null = '') => `/report/${type}/${id}`;
export const getReportsRoute = (permanentUrl: string) => getLinkRoute(ROUTE_REPORTS, { permanentUrl });

export const reportRoutes: CRoutes = [
  {
    path: types.map((type) => [`/report/${type}/:reportId?`, `/report/:permanentUrl/${type}`]).flat(1),
    Component: ReportPage,
    exact: true,
    showFooter: false,
  },
  {
    path: ROUTE_REPORTS,
    Component: ReportsListPage,
    exact: true,
    showFooter: false,
  },
];
